import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import ERP_Store from './redux/Store';
import { GoogleMapsProvider } from './components/providers/GoogleMapsProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <Provider store={ERP_Store} >
      <GoogleMapsProvider>
        <App />
      </GoogleMapsProvider>
    </Provider>
  </BrowserRouter>
  // </React.StrictMode>
);